import helpers from '../base-class/helpers.js';

export default function(ngModule) {
    ngModule.factory('Role', function(BaseClass, $http, $q) {

        const urlPrefix = AUTH_API_ROOT;

        function Role(attributes) {
            _.assign(this, attributes);
        }
        Role.modelName = 'Role';

        BaseClass.apply(Role);
        Role.primaryKey = 'id';
        Role.configureApi(urlPrefix + '/roles/:user_id/:id');

        Role.configureAPIMessages({
            'PUT /roles/:user_id/:id': {
                406: 'models.role.notice.alreadyAssigned'
            },
            'DELETE /roles/:user_id/:id': {
                400: 'models.role.notice.roleLoss',
                406: 'models.role.notice.notAssigned'
            }
        });

        Role.prototype.$attach = function(userId) {
            return $http.put(urlPrefix + `/roles/${userId}/${this.id}`).catch(error => {
                this.broadcastAPIMessage(error);
                return $q.reject(error);
            });
        };

        Role.prototype.$detach = function(userId) {
            return $http.delete(urlPrefix + `/roles/${userId}/${this.id}`).catch(error => {
                this.broadcastAPIMessage(error);
                return $q.reject(error);
            });
        };

        // Get the currently logged in user's roles, for which the correct company is retrieved out of the access token
        Role.getUserRoles = function(user) {

            return user.$queryRole(false)
                .then(roles => {
                    _.forEach(roles, role => {
                        user.belongsToMany.cache('Role', role);
                    });

                    Role.isAdmin = !!_.find(roles, r => /^(?:Whitelabel )?Admin$/.test(r.name));

                    Role.authorizedAs = roles;

                    return roles.slice(0);

                });

        };

        Role.getUserRolesFromToken = function(user) {

            return user.$queryTokenRoles(false)
                .then(roles => {
                    _.forEach(roles, role => {
                        user.belongsToMany.cache('Role', role);
                    });

                    Role.isAdmin = !!_.find(roles, r => /^(?:Whitelabel )?Admin$/.test(r.name));

                    Role.authorizedAs = roles;

                    return roles.slice(0);

                });

        };

        Role.isAuthorizedAs = function(role) {
            if(Role.isAdmin && role !== 'Admin')
                return true;
            return !!_.find(Role.authorizedAs, r => r.name === role);
        };

        return Role;
    });
}
